import {
  getRecurringsRequestList,
  RecurringRequestListResponse,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* RecurringsListRequest(
  self: Self,
  query: string
): Generator<Promise<FlowReturn<RecurringRequestListResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getRecurringsRequestList(query);
    const { SearchRecurringRequestForSubMerchant, status } = (
      response as RecurringRequestListResponse
    ).data;
    if (SearchRecurringRequestForSubMerchant?.Recurring) {
      self.recurringRequest.reset();
      self.recurringRequest.list = cast(
        SearchRecurringRequestForSubMerchant?.Recurring
      );
      self.recurringRequest.pagination =
        SearchRecurringRequestForSubMerchant?.PaginationInfo;
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status?.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default RecurringsListRequest;
